import { render, staticRenderFns } from "./FilterTag.vue?vue&type=template&id=4c43a166&"
import script from "./FilterTag.vue?vue&type=script&lang=js&"
export * from "./FilterTag.vue?vue&type=script&lang=js&"
import style0 from "./FilterTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports